import { TFunction } from 'i18next';
import { DropdownItemProps } from './DropdownItems';

// Use the value to lookup and return the corresponding string value from the items list.
export const getDropdownItemStringValue = <T>(
  items: DropdownItemProps<T>[],
  value: T,
): string | undefined => {
  const index = items.findIndex((item: DropdownItemProps<T>) => {
    return item.value === value;
  });

  const isIndexInRange = index >= 0 && index < items.length;
  return isIndexInRange ? items[index].stringValue : undefined;
};

// Use the string value to lookup and return the corresponding value from the items list.
export const getDropdownItemValue = <T>(
  items: DropdownItemProps<T>[],
  stringValue: string,
): T | undefined => {
  const index = items.findIndex((item: DropdownItemProps<T>) => {
    return item.stringValue === stringValue;
  });

  const isIndexInRange = index >= 0 && index < items.length;
  return isIndexInRange ? items[index].value : undefined;
};

export const createNullOption = (
  t: TFunction,
  transKey = 'NotSpecified',
): DropdownItemProps<null> => ({
  key: transKey,
  value: null,
  stringValue: transKey,
  label: t(transKey),
});
